<template>
    <el-dialog title="修改个人信息" v-model="edit_info" @closed="close_edit_info">
        <el-form style="margin: 20px;">
            <div class="step_one_content">
                <el-form-item label="头像">
                    <img v-if="agent.logo !== null"
                         class="img-upload-preview img-circle"
                         width="100"
                         height="100"
                         :src="agent.logo" alt="preview">
                    <img v-else
                         class="img-upload-preview img-circle"
                         width="100"
                         height="100"
                         :src="logo">
                    <input type="file"
                           class="form-control form-control-file"
                           id="uploadImg"
                           name="uploadImg"
                           @change="img_change" accept="image/*">
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="agent.name" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="昵称">
                    <el-input v-model="agent.nickname" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                    <el-input type="textarea" v-model="agent.introduction" style="min-width: 300px;"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <template #footer>
    <span class="dialog-footer">
      <el-button @click="edit_info = false">取 消</el-button>
      <el-button type="primary" @click="submit_info">确 定</el-button>
    </span>
        </template>
    </el-dialog>
</template>

<script>
import api from '@/api'
import axios from "axios";
import logo from '@/assets/logo.png';

export default {
    name: 'EditInfo',
    props: {
        show: Number
    },
    data() {
        return {
            edit_info: false,
            agent: {},
            logo: logo,
        }
    },
    watch: {
        show(new_val) {
            this.edit_info = new_val > 0;
        }
    },
    created() {
        this.agent = JSON.parse(localStorage.getItem('user_info'))
    },
    methods: {
        close_edit_info(e) {
            this.edit_info = false
        },
        img_change(event) {
            let file = event.target.files[0]

            this.formData = new FormData()
            this.formData.append('file', file, file.name)

            let that = this
            axios.post(
                api.agent.change_header, this.formData
            ).then(function (res) {
                that.agent.logo = res.data.data.path;
            }).catch(function (err) {
                if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err.message)
                }
            });
        },
        submit_info() {
            this.edit_info = false
            let that = this

            axios.post(
                api.agent.update, this.agent
            ).then(function (res) {
                if (res.data.code === 10000) {
                    that.$notify({
                        title: '成功',
                        message: '信息录入成功',
                        type: 'success'
                    });
                    that.$router.go(0);
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: res.data.data.msg
                    });
                }
            }).catch(function (err) {
                that.$notify.error({
                    title: '错误',
                    message: err.response.data.msg
                });
            });
        },
    }
}
</script>

<style scoped>
h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}
</style>
